import React from "react";
import ReactDOM from "react-dom/client";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import "@/index.css";
import App from "@/App";
import { handleApplePopupIfPresent } from "@/lib/applePopupBridge";

// If this tab is the Apple Sign-In popup (URL fragment contains
// #code=... / #id_token=... / #error=...), relay the payload to the
// opener via localStorage / BroadcastChannel / postMessage and close
// the window. We DO NOT mount React in that case — the popup is a
// throwaway that only exists to receive Apple's redirect.
if (!handleApplePopupIfPresent()) {
  const queryClient = new QueryClient({
    defaultOptions: {
      queries: {
        staleTime: 60_000,
        refetchOnWindowFocus: false,
      },
    },
  });

  const root = ReactDOM.createRoot(document.getElementById("root"));
  root.render(
    <React.StrictMode>
      <QueryClientProvider client={queryClient}>
        <App />
      </QueryClientProvider>
    </React.StrictMode>,
  );
}
